module.exports = __webpack_public_path__ + "img/5_23.a667bd84.jpg";